<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="step() !== 'opening'" [style]="{ width: '420px' }" [header]="header()">
  <div class="otp">
    @switch (step()) {
      @case ('opening') {
        <div class="otp__center">
          <i class="pi pi-spin pi-spinner otp__icon otp__icon--muted"></i>
          <p class="otp__text">{{ 'Signing_Otp_Opening' | translateWF: 'Opening your signing session…' }}</p>
        </div>
      }

      @case ('otp') {
        <div class="otp__channel">
          <i class="pi pi-mobile"></i>
          <span>Microsoft Authenticator</span>
        </div>
        <p class="otp__lead">
          {{ 'Signing_Otp_Lead' | translateWF: 'Open your authenticator app and type the 6-digit code shown for' }}
          <span class="otp__phone">Sierra Nexus</span>.
        </p>

        <div class="otp__inputs" (keydown.enter)="submit()">
          <p-inputotp [(ngModel)]="code" [length]="6" [integerOnly]="true" [disabled]="verifying()" />
        </div>

        <div class="otp__meta">
          @if (windowClosed()) {
            <span class="otp__meta-danger">{{ 'Signing_Otp_WindowClosed' | translateWF: 'Time is up for this session. Close it and open a new one.' }}</span>
          } @else {
            <span>
              {{ 'Signing_Otp_WindowLeft' | translateWF: 'Time left to enter it' }}
              <strong class="otp__mono">{{ windowLeft() }}</strong>
            </span>
          }
          <span class="otp__meta-sep">·</span>
          <span>{{ attemptsRemaining() }} {{ 'Signing_Otp_AttemptsLeft' | translateWF: 'attempts left' }}</span>
        </div>

        @if (error()) {
          <div class="otp__error">{{ error() }}</div>
        }

        <div class="otp__resend">
          {{ 'Signing_Otp_Hint' | translateWF: 'The code changes every 30 seconds. If it is about to change, wait for the next one.' }}
        </div>

        <div class="otp__resend">
          <a href="#" class="otp__link" (click)="openLostAccess($event)">{{ 'Signing_Otp_LostAccess' | translateWF: 'Lost access to your authenticator app?' }}</a>
        </div>
      }

      @case ('verified') {
        <div class="otp__center">
          <i class="pi pi-check-circle otp__icon otp__icon--success"></i>
          <p class="otp__text">
            {{ 'Signing_Otp_Verified' | translateWF: 'Identity verified. Your session is now active — open any document below to start signing.' }}
          </p>
        </div>
      }

      @case ('ended') {
        <div class="otp__center">
          <i class="pi pi-lock otp__icon otp__icon--danger"></i>
          <p class="otp__text">{{ endedMessage() }}</p>
        </div>
      }

      @case ('error') {
        <div class="otp__center">
          <i class="pi pi-exclamation-circle otp__icon otp__icon--danger"></i>
          <p class="otp__text">{{ error() }}</p>
        </div>
      }
    }
  </div>

  <ng-template #footer>
    @switch (step()) {
      @case ('otp') {
        <p-button variant="text" label="{{ 'Cancel' | translateWF: 'Cancel' }}" (onClick)="close()" />
        <p-button label="{{ 'Signing_Otp_Submit' | translateWF: 'Verify & Enter' }}" [disabled]="!canSubmit" [loading]="verifying()" (onClick)="submit()" />
        <p-button severity="danger" icon="pi pi-times-circle" label="{{ 'Signing_Otp_CloseSession' | translateWF: 'Close Session' }}" (onClick)="requestCloseSession()" />
      }
      @case ('ended') {
        <p-button variant="text" label="{{ 'Signing_Close' | translateWF: 'Close' }}" (onClick)="close()" />
        <p-button icon="pi pi-lock-open" label="{{ 'Signing_Dashboard_NewSession' | translateWF: 'New Session' }}" (onClick)="startAgain()" />
      }
      @case ('error') {
        <p-button label="{{ 'Signing_Close' | translateWF: 'Close' }}" (onClick)="close()" />
      }
    }
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="confirmCloseOpen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '400px' }"
  header="{{ 'Signing_Otp_CloseSession_Title' | translateWF: 'Close this signing session?' }}"
>
  <p class="otp-confirm__text">
    {{ 'Signing_Otp_CloseSession_Body' | translateWF: 'The session will be discarded without being verified. You can open a new one whenever you are ready to sign.' }}
  </p>
  <ng-template #footer>
    <p-button variant="text" label="{{ 'Cancel' | translateWF: 'Cancel' }}" (onClick)="confirmCloseOpen.set(false)" />
    <p-button severity="danger" label="{{ 'Signing_Otp_CloseSession' | translateWF: 'Close Session' }}" [loading]="closing()" (onClick)="confirmCloseSession()" />
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="lostAccessOpen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '440px' }"
  header="{{ 'Signing_LostAccess_Title' | translateWF: 'Lost access to your authenticator?' }}"
>
  <div class="otp-confirm">
    <p class="otp-confirm__text">
      {{
        'Signing_LostAccess_Body'
          | translateWF
            : 'If you deleted the Sierra Nexus account from the app, changed phones or lost your phone, you cannot generate codes anymore. For security, you cannot set it up again on your own.'
      }}
    </p>
    <ol class="otp-confirm__steps">
      <li>{{ 'Signing_LostAccess_Step1' | translateWF: 'Ask a user administrator to reset your authenticator.' }}</li>
      <li>{{ 'Signing_LostAccess_Step2' | translateWF: 'Then come back to the Signing Dashboard and choose “Set Up Authenticator”.' }}</li>
      <li>{{ 'Signing_LostAccess_Step3' | translateWF: 'Scan the new QR code. The old one will no longer work.' }}</li>
    </ol>
    <p class="otp-confirm__hint">
      {{ 'Signing_LostAccess_Backup' | translateWF: 'Tip: if you had cloud backup turned on in Microsoft Authenticator, restoring it on your phone may bring the account back.' }}
    </p>
  </div>
  <ng-template #footer>
    <p-button label="{{ 'Signing_Close' | translateWF: 'Close' }}" (onClick)="lostAccessOpen.set(false)" />
  </ng-template>
</p-dialog>
